<script lang="ts">
import { lateinit } from 'tg-commons'
import { bindEvents, type LatLngBounds, type RectangleEventMap, type RectangleOptions, type RectangleOverlay } from 'tg-map-core'
import { defineComponent, type PropType } from 'vue'
import { eventProp, optionalProp, requiredProp, useSplittedAttrs, type EventEmits, type EventProps, type Props } from '../../utils/vue-utils'
import MapMixin from '../map-mixin'
type TgRectangleEmits = {
  'update:bounds': LatLngBounds,
}
export default defineComponent({
  name: 'tg-rectangle',
  mixins: [MapMixin],
  inheritAttrs: false,
  props: {
    bounds: requiredProp(Object as PropType<LatLngBounds>),
    clickable: optionalProp(Boolean),
    editable: optionalProp(Boolean),
    strokeColor: optionalProp(String),
    strokeOpacity: optionalProp(Number),
    strokeWeight: optionalProp(Number),
    visible: optionalProp(Boolean),
    zIndex: optionalProp(Number),
    fillColor: optionalProp(String),
    fillOpacity: optionalProp(Number),
    'onUpdate:bounds': eventProp(),
  } satisfies Props<RectangleOptions> & EventProps<TgRectangleEmits>,
  emits: undefined as any as EventEmits<RectangleEventMap & TgRectangleEmits>,
  setup(props, { attrs }) {
    return {
      attrs: useSplittedAttrs(attrs, props),
      overlay: lateinit<RectangleOverlay>(),
      emittedBounds: undefined as LatLngBounds | undefined,
    }
  },
  watch: {
    bounds(value: LatLngBounds) {
      if (this.emittedBounds != null) {
        const bounds = this.emittedBounds
        this.emittedBounds = undefined
        // bounds很大可能会被重新创建, 故需要严格比较相等
        if (bounds.equals(value)) {
          // 防止emit出的值又被设置回来
          return
        }
      }
      this.overlay.setBounds(value)
    },
    clickable() {
      this.recreate()
    },
    editable(value) {
      this.overlay.setEditable(value)
    },
    strokeColor(value) {
      this.overlay.setStrokeColor(value)
    },
    strokeOpacity(value) {
      this.overlay.setStrokeOpacity(value)
    },
    strokeWeight(value) {
      this.overlay.setStrokeWeight(value)
    },
    fillColor(value) {
      this.overlay.setFillColor(value)
    },
    fillOpacity(value) {
      this.overlay.setFillOpacity(value)
    },
    visible(value) {
      this.overlay.setVisible(value)
    },
    zIndex(value) {
      this.overlay.setZIndex(value)
    },
  },
  onCreate() {
    this.overlay = this.$map.createRectangle(this)
    this.$map.addOverlay(this.overlay)
    bindEvents(this.attrs.listeners, this.overlay, this.$emit)
    if (this.attrs.listenerProps['update:bounds']) {
      this.overlay.addEventListener('bounds-changed', () => {
        this.$emit('update:bounds', this.emittedBounds = this.overlay.getBounds())
      })
    }
  },
  onDestroy() {
    this.$map.removeOverlay(this.overlay)
  },

})
</script>
